import React, { useState, useEffect } from "react";
import "../refinance/remaining-balance.css";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const RemainingBalance = ({ formData, setForm, navigation, step }) => {
  const [priceInputValue, setpriceInputValue] = useState(0);
  const [priceInput] = useState({
    0: "0",
    1: "100,000",
    2: "110,000",
    3: "120,000",
    4: "130,000",
    5: "140,000",
    6: "150,000",
    7: "160,000",
    8: "170,000",
    9: "180,000",
    10: "190,000",
    11: "200,000",
    12: "210,000",
    13: "220,000",
    14: "230,000",
    15: "240,000",
    16: "250,000",
    17: "260,000",
    18: "270,000",
    19: "280,000",

    20: "290,000",
    21: "300,000",
    22: "310,000",
    23: "320,000",
    24: "330,000",
    25: "340,000",
    26: "350,000",
    27: "360,000",
    28: "370,000",
    29: "380,000",
    30: "390,000",
    31: "400,000",
    32: "410,000",
    33: "420,000",
    34: "430,000",
    35: "440,000",
    36: "450,000",
    37: "460,000",
    38: "470,000",
    39: "480,000",
    40: "490,000",
    41: "500,000",
    42: "525,000",
    43: "550,000",
    44: "575,000",
    45: "600,000",
    46: "625,000",
    47: "650,000",
    48: "675,000",
    49: "700,000",
    50: "725,000",
    51: "750,000",
    52: "775,000",
    53: "800,000",
    54: "825,000",
    55: "850,000",
    56: "875,000",
    57: "900,000",
    58: "925,000",
    59: "950,000",
    60: "975,000",
    61: "1,000,000",
    62: "1,100,000",
    63: "1,200,000",
    64: "1,300,000",
    65: "1,400,000",
    66: "1,500,000",
    67: "1,600,000",
    68: "1,700,000",
    69: "1,800,000",
    70: "1,900,000",
    71: "2,000,000",
    72: "2,100,000",
    73: "2,200,000",
    74: "2,300,000",
    75: "2,400,000",
    76: "2,500,000",
    77: "2,600,000",
    78: "2,700,000",
    79: "2,800,000",
    80: "2,900,000",
    81: "3,000,000",
  });

  const [isVisible] = useState(true);
  const [error, setError] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const slider = React.createRef();
  const sliderValue = React.createRef();
  console.log(priceInput[priceInputValue]);
  useEffect(() => {
    slider.current.setAttribute("min", 0);
    slider.current.setAttribute("max", Object.keys(priceInput).length - 1);
    const thumbSize = parseInt(window.getComputedStyle(sliderValue.current).getPropertyValue("--thumb-size"), 10);
    handleSliderValuePosition(slider.current, thumbSize);
  }, [priceInputValue]);

  const handlePricingSlide = (e) => {
    setpriceInputValue(e.target.value);
    handleSliderValuePosition(e.target);
  };

  useEffect(() => {
    formData.RemainingBalance = priceInput[priceInputValue];
  }, [priceInputValue]);

  const handleSliderValuePosition = (input, thumbSize) => {
    const multiplier = input.value / input.max;
    const thumbOffset = thumbSize * multiplier;
    const priceInputOffset = (thumbSize - sliderValue.current.clientWidth) / 2;
    sliderValue.current.style.left = input.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
  };

  const handleNextAndSubmit = () => {
    if (formData.RemainingBalance === "0") {
      return setError(true);
    }
    setError(false);
    navigation.next();
  };

  return (
    <div className={stepStyles.page}>
      <div className="w-full">
        <ProgressBar width={"40%"} />
        <div className={stepStyles.content}>
          {transition((style, item) =>
            item ? (
              <animated.div style={style} className={stepStyles.panel}>
                <h1 className={stepStyles.title}>What is your current mortgage balance?</h1>
                <div className="pricing">
                  <div className="pricing-slider center-content">
                    <label className="form-slider">
                      <input
                        type="range"
                        ref={slider}
                        defaultValue={priceInputValue}
                        onChange={handlePricingSlide}
                        name="homeValue"
                      />
                    </label>
                  </div>
                  <div ref={sliderValue} className="pricing-slider-value">
                    <h2 className={stepStyles.sliderValue}>${priceInput[priceInputValue]}</h2>
                  </div>
                </div>
                {error ? <div className={stepStyles.sliderError}>Please select a current mortgage balance</div> : null}
              </animated.div>
            ) : null,
          )}
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => handleNextAndSubmit()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemainingBalance;
